import { createContext as t, useContext as o } from "react";
const e = t({
  deferred: !1,
  schema: void 0,
  setSchema: () => {
  }
}), c = e.Provider, s = () => o(e);
export {
  e as SchemaContext,
  c as SchemaProvider,
  s as useSchema
};
//# sourceMappingURL=SchemaContext.js.map
